export { default as Content } from './Content/Content'
export { default as Footer } from './Footer/Footer'
